<breadcrumb
  [paginas]="[
    { route: '/home', name: 'Home' },
    { route: '/aprovacao-ajuste-ponto', name: 'Aprovação de Ajuste de Ponto' }
  ]"
></breadcrumb>

<!-- TÍTULO + botão voltar -->
<section class="section-saudacao">
  <div class="container header-ajuste">
    <h2 class="titulo-page">Aprovação Ajuste de Ponto</h2>
    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>

  <!-- BOAS-VINDAS + DADOS PRINCIPAIS -->
  <div class="container boas-vindas">
  <p>
     Olá, <b>{{ userLogado?.nome }}</b>! 👋
  </p>
  <!-- diretoria / escola -->
     <p class="icon-paragraph">
      <i class="fa-solid fa-user"></i>
      <b>Nome Psicologo</b> {{ jornada?.nomePsicologo }}
     </p>

  <p class="icon-paragraph">
    <img
      src="../../../assets/img/icons/icon-nome-escola.svg"
      title="Diretoria de Ensino"
      alt=""
    />
    <b>URE: </b> {{ jornada?.nomeDiretoria }}
  </p>
  <p class="icon-paragraph">
    <img
      src="../../../assets/img/icons/icon-nome-escola.svg"
      title="Diretoria de Ensino"
      alt=""
    />
    <b>Escola: </b> {{ jornada?.nomeEscola }}
  </p>
  <p class="icon-paragraph data-paragraph">
    <img
      src="../../../assets/img/icons/icon-calendario.svg"
      title="Diretoria de Ensino"
      alt=""
    />
    <b> {{jornada?.dataEntrada}} </b>
  </p>
</div>
</section>

<section class="section-data-regitro-saida">
  <div class="container">
    <div class="conteudo-data-check-in-out">
      <!-- horários -->
      <div class="conteudo-check">
        <p>
          Hora Check in:
          <input
              type="time"
              class="input-time"
              [value]="dataInicio | date:'HH:mm'"
              [ngClass]="{ 'input-alterado': isAjusteEntrada }"
              placeholder="Hora Check-Out"
              aria-label="Hora Check-Out"
              [disabled]="true"
            />
        </p>
        <p>
          Hora Check-Out:
          <input
              type="time"
              class="input-time"

              [value]="dataFim | date:'HH:mm'"
              [ngClass]="{ 'input-alterado': isAjusteSaida }"
              placeholder="Hora Check-Out"
              aria-label="Hora Check-Out"
              [disabled]="true"
            />
        </p>

      </div>
    </div>
        <p class="horas-trabalhadas" *ngIf="jornada?.dataInicio && jornada?.dataFim">
          Total de horas trabalhadas:<b>{{ totalHorasTrabalhadas | date:'HH:mm' }}</b>
        </p>
  </div>
</section>

<!-- JUSTIFICATIVAS -->
<section class="section-aprovacao-registro">
  <div class="container">
    <!-- JUSTIFICATIVAS -->
    <div class="justificativas">
      <!-- Entrada -->
      <div *ngIf="jornada?.dsJustificativaEntrada" class="grupo-filter-full">
        <label class="label-textarea">Justificativa de Entrada: </label>
        <textarea
          class="input-textarea"
          placeholder="Digite a justificativa para o ajuste na saída"
          aria-label="Justificativa"
          readonly
          [value]="jornada?.dsJustificativaEntrada"
          rows="4"
        ></textarea>
      </div>
      <!-- Saída -->
      <div *ngIf="jornada?.dsJustificativaSaida" class="grupo-filter-full">
        <label class="label-textarea">Justificativa de Saída: </label>
        <textarea
          class="input-textarea"
          placeholder="Digite a justificativa para o ajuste na saída"
          aria-label="Justificativa"
          readonly
          [value]="jornada?.dsJustificativaSaida"
          rows="4"
        ></textarea>
      </div>
    </div>

    <div class="conteudo-btn-aprovacao-registro">
      <input type="button" class="btn-reprovar" (click)="showRepproveConfirm = true"  value="Reprovar" />
      <input type="submit" class="btn-aprovar" (click)="showApproveConfirm = true" value="Aprovar" />
    </div>
  </div>
</section>


<section class="section-grid-consulta-ponto">
  <div class="container">
    <div class="row_registros">
      <h3>Atividades Registradas</h3>
    </div>
    <div class="grid-datatable">
      <app-tabulator-table
        [columnNames]="gridAtividades"
        [tipoRelatorio]="2"
        [tableData]="atividade"
        [orientacaoPortrait]="false"
      >
      </app-tabulator-table>
    </div>
  </div>
</section>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>

  <app-modal *ngIf="showApproveConfirm">
      <div class="modal-content">
        <div class="modal-header">
          <p>Tem certeza que deseja aprovar esse ajuste de ponto?</p>
          <button class="btn-fechar-modal" (click)="closeModalApproveConfirm()">
            ✖
          </button>
        </div>
    <div class="modal-buttons">
      <button class="btn-primary" (click)="confirmarAprovacao()">Sim</button>
      <button class="btn-outline" (click)="showApproveConfirm = false">Não</button>
    </div>
  </div>
  </app-modal>

    <app-modal *ngIf="showRepproveConfirm">
      <div class="modal-content">
         <div class="modal-header">
           <p>Tem certeza que deseja reprovar esse ajuste de ponto?</p>
          <button class="btn-fechar-modal" (click)="closeModalRepproveConfirm()">
            ✖
          </button>
         </div>
    <div class="modal-buttons">
      <button class="btn-primary" (click)="confirmarReprovacao()">Sim</button>
      <button class="btn-outline" (click)="showRepproveConfirm = false">Não</button>
    </div>
  </div>
  </app-modal>
